import { isSameOrAfter } from "@oysterhr/common"
import { DateTime } from "luxon"

const isInvalidJsonString = (str: string) => {
  try {
    JSON.parse(str)
  } catch {
    return true
  }

  return false
}

export const STORED_CSRF_COUNTER = "InvalidCsrfTokenReloadCount"

export const removeInvalidCsrfTokenReloadCount = () => {
  localStorage.removeItem(STORED_CSRF_COUNTER)
}

export const getInvalidCsrfTokenReloadCount = () => {
  const invalidCsrfTokenReloadCount = window.localStorage.getItem(STORED_CSRF_COUNTER)
  if (!invalidCsrfTokenReloadCount || isInvalidJsonString(invalidCsrfTokenReloadCount))
    return { value: 0 }

  const parsedInvalidCsrfTokenReloadCount = JSON.parse(invalidCsrfTokenReloadCount)

  return {
    value: +parsedInvalidCsrfTokenReloadCount.value || 0,
    expiry: parsedInvalidCsrfTokenReloadCount.expiry,
  }
}

export const bumpInvalidCsrfTokenReloadCount = () => {
  const invalidCsrfTokenReloadCount = getInvalidCsrfTokenReloadCount().value

  localStorage.setItem(
    STORED_CSRF_COUNTER,
    JSON.stringify({
      value: invalidCsrfTokenReloadCount + 1,
      expiry: DateTime.now().plus({ minute: 1 }),
    }),
  )
}

export const expireInvalidCsrfTokenReloadCount = () => {
  const invalidCsrfTokenReloadCount = getInvalidCsrfTokenReloadCount()

  if (
    invalidCsrfTokenReloadCount.value === 1 &&
    isSameOrAfter(DateTime.now(), invalidCsrfTokenReloadCount.expiry)
  ) {
    removeInvalidCsrfTokenReloadCount()
  }
}
